import React from "react";
import Button from "../../../components/ui/Button";

export const SuccessfullBanner = ({
  btnText,
  title,
  handler,
}: {
  btnText?: string;
  title?: string;
  handler?: any;
}) => {
  return (
    <div className="flex flex-col items-center justify-center gap-3">
      {/* <img src="/images/svg/moneyhop-logo.svg" alt="sbm-white-logo" width="457px" height="115px" /> */}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="75"
        height="75"
        viewBox="0 0 101 100"
        fill="none"
      >
        <path
          d="M31.7497 49.9999L44.2497 62.4999L69.2497 37.4999M92.1663 49.9999C92.1663 73.0118 73.5115 91.6666 50.4997 91.6666C27.4878 91.6666 8.83301 73.0118 8.83301 49.9999C8.83301 26.9881 27.4878 8.33325 50.4997 8.33325C73.5115 8.33325 92.1663 26.9881 92.1663 49.9999Z"
          stroke="#0F5BF1"
          stroke-width="6"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      <div className="flex flex-col items-center justify-center gap-3">
        <p className="text-[#000] font-semibold text-center font-roboto xl:text-4xl lg:text-2xl">
          Success!
        </p>
        <p className="text-[#000] font-medium text-center font-roboto xl:text-xl lg:text-base">
          {title}
        </p>
      </div>
      <Button
        bgColor={"bg-primary-1050"}
        fontStyle={{
          fontFamily: "font-inter",
          fontSize: "text-base",
          fontWeight: "font-semibold",
          fontColor: "text-[#fff]",
        }}
        borderStyle={{
          borderWidth: "border",
          borderRadius: "rounded-lg",
          borderColor: "border-[#0F5BF1]",
        }}
        className="w-full h-[46.104px] text-center text-[#fff] mb-2"
        onClickHandler={() => handler && handler()}
      >
        {btnText}
      </Button>
    </div>
  );
};
